import { QueryClient, useQuery } from '@tanstack/react-query';
import { getApi } from '../../../../shared/api';

export const salesDetailsQueryKey = (salesId: string) => ['sales-details', salesId];

// Lets a caller await the sale details and prime the cache that useSalesDetails reads from, so a
// screen can hold its loader until the sale has resolved instead of rendering a half-filled view.
export const fetchSalesDetails = (queryClient: QueryClient, salesId: string) =>
    queryClient.fetchQuery({
        queryKey: salesDetailsQueryKey(salesId),
        queryFn: () => getApi().getApiSalesDetailsId(salesId),
    });

export const useSalesDetails = (salesId: string | undefined, enabled: boolean = true) => {
    const api = getApi();

    const shouldFetch = enabled && !!salesId;

    return useQuery({
        queryKey: shouldFetch ? salesDetailsQueryKey(salesId!) : [],
        queryFn: () => (shouldFetch ? api.getApiSalesDetailsId(salesId!) : Promise.resolve(undefined)),
        enabled: shouldFetch,
        staleTime: 0,
        retry: 1,
    });
};
